import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsmAuthService, CsAgentAuthService } from '@spartacus/asm/root';
import { BaseSiteService, OCC_USER_ID_ANONYMOUS, OCC_USER_ID_CURRENT, UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs/internal/Observable';
import { distinctUntilChanged, tap } from 'rxjs/operators';

@Injectable()
export class HttpAsmCustomerIdInterceptor implements HttpInterceptor {
  isAsmLoggedIn: boolean;
  customerId: string;
  constructor(private csAgentAuthService: CsAgentAuthService, private userIdService: UserIdService) {
    this.csAgentAuthService
      .isCustomerSupportAgentLoggedIn()
      .pipe(
        distinctUntilChanged(),
        tap((isAsmLoggedIn) => {
          this.isAsmLoggedIn = isAsmLoggedIn;
        })
      )
      .subscribe();
    this.userIdService
      .getUserId()
      .pipe(
        distinctUntilChanged(),
        tap((userId) => {
          this.customerId = userId;
        })
      )
      .subscribe();
  }

  intercept(request: HttpRequest<any[]>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      this.isAsmLoggedIn &&
      this.customerId &&
      this.customerId !== OCC_USER_ID_CURRENT &&
      this.customerId !== OCC_USER_ID_ANONYMOUS
    ) {
      request = request.clone({
        params: request.params.set('asmcustomerid', this.customerId),
      });
    }
    return next.handle(request);
  }
}
